var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapfre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 1046.34 126.97923",
    width: 1046.34,
    height: 126.97923,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs41"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_208",
    "data-name": "Grupo 208",
    transform: "translate(-151.66,-477.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_325",
    "data-name": "Trazado 325",
    d: "m 1120.29,498.18 v 32.27 H 1198 v 20.83 h -77.71 v 32.14 H 1198 v 20.83 H 1073.45 V 477.37 H 1198 v 20.81 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_326",
    "data-name": "Trazado 326",
    d: "m 1055.85,571.49 a 31.72,31.72 0 0 0 -31.7,-30.67 31.71,31.71 0 0 0 0,-63.42 h -92.94 v 126.84 h 47.62 V 551.69 H 989 a 20.81,20.81 0 0 1 20.81,20.81 v 31.7 h 46.07 v -31.7 c -0.03,-0.33 -0.02,-0.65 -0.03,-1.01 z M 989,529.93 H 978.83 V 492 H 989 a 18.62,18.62 0 0 1 20.73,16.22 c 0,0.3 0.06,0.61 0.08,0.92 A 20.81,20.81 0 0 1 989,530 v 0 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_327",
    "data-name": "Trazado 327",
    d: "m 837.11,498.18 v 32.27 h 77.71 v 20.83 h -77.71 v 53 H 790.26 V 477.37 h 124.55 v 20.81 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_328",
    "data-name": "Trazado 328",
    d: "m 737,477.42 h -87.64 v 126.82 h 46.8 V 551.39 H 737 a 37,37 0 0 0 0,-74 v 0 z m -29.89,52.49 H 697 v -38 h 10.15 c 10.56,0 20.83,5.65 20.83,17.15 a 20.65,20.65 0 0 1 -20.47,20.82 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_329",
    "data-name": "Trazado 329",
    d: "m 598,477.37 h -82.79 l -36.44,126.87 h 46.85 l 6,-20.82 h 50 l 6,20.82 h 46.85 z m -60.41,85.22 19,-66.22 19,66.22 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_330",
    "data-name": "Trazado 330",
    d: "M 463.73,477.37 V 604.24 H 416.88 V 540.8 l -31,63.44 -31,-63.44 v 63.44 h -46.8 V 477.37 h 46.85 l 31,63.43 31,-63.43 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_331",
    "data-name": "Trazado 331",
    d: "m 278.57,540.8 a 64,64 0 0 1 -0.5,8 H 272 a 57.42,57.42 0 1 0 -114.28,-8 58.66,58.66 0 0 0 0.54,8 v 0 a 57.43,57.43 0 0 0 113.74,0 h 6.09 a 63.46,63.46 0 0 1 -125.93,0 66,66 0 0 1 -0.5,-8 63.47,63.47 0 0 1 126.93,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_332",
    "data-name": "Trazado 332",
    d: "m 256.92,542 a 37,37 0 0 0 -4.39,-12 39.81,39.81 0 0 0 -8.69,-10.18 9.07,9.07 0 0 0 -7.57,-1.64 11.53,11.53 0 0 0 -6.12,-6.57 44,44 0 0 0 -30,0 7.25,7.25 0 0 0 -1.24,0.56 10.09,10.09 0 0 0 -5,6.11 10.67,10.67 0 0 0 -8,1.9 37.11,37.11 0 0 0 -12.62,21.8 6.25,6.25 0 0 0 -0.11,1.29 9.51,9.51 0 0 0 1.44,5.42 v 0 a 9.4,9.4 0 0 0 8.4,4.34 l 20.64,-0.06 c 1.47,0.06 5.36,0.07 8.33,0.07 v 19.44 h 6.21 v -19.37 c 3,0 6.87,0 8.34,-0.07 l 20.64,0.06 a 9.45,9.45 0 0 0 8.41,-4.34 9.69,9.69 0 0 0 1.44,-5.42 8.05,8.05 0 0 0 -0.11,-1.34 z m -51.6,4 a 1.59,1.59 0 0 1 -1.5,0.82 h -21 a 3.15,3.15 0 0 1 -3.42,-2.82 2.53,2.53 0 0 1 0,-0.55 30.28,30.28 0 0 1 3.66,-10.27 31.09,31.09 0 0 1 6.85,-8.17 L 190,525 a 3.17,3.17 0 0 1 4.44,0.62 3.61,3.61 0 0 1 0.35,0.6 l 10.46,18.22 a 1.59,1.59 0 0 1 0,1.62 z m 11.5,-0.23 a 2,2 0 0 1 -1.74,1.09 1.94,1.94 0 0 1 -1.75,-1.12 l -13,-22.37 a 3.89,3.89 0 0 1 1,-5.43 3.6,3.6 0 0 1 0.54,-0.31 37.13,37.13 0 0 1 13.19,-2.42 37.8,37.8 0 0 1 12.94,2.29 l 0.15,0.07 a 3.91,3.91 0 0 1 2.06,5.12 3.62,3.62 0 0 1 -0.42,0.74 z m 32.39,0.65 a 3,3 0 0 1 -1.84,0.41 l -21,-0.05 a 1.56,1.56 0 0 1 -1.44,-2.46 l 10.45,-18.23 a 3.24,3.24 0 0 1 1.31,-1.43 3.11,3.11 0 0 1 3.49,0.22 l 0.1,0.08 a 30.44,30.44 0 0 1 10.51,18.43 3.15,3.15 0 0 1 -1.54,3 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapfre);
export default __webpack_public_path__ + "static/media/mapfre.55e33e931a3859b89c19cd687ca05ebf.svg";
export { ForwardRef as ReactComponent };